import React from 'react';
import * as componentStyle from './errorMessage.module.scss';

export default function ErrorMessage({ 
  message, 
  className 
}: { 
  message: string; 
  className?: string; 
}) {
  return (
    <>
      {message && (
        <div className={`${className} mt-2 ${componentStyle.sentenceCase}`}>
          {message}
        </div>
      )}
    </>
  )
}
